/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import {
  Link,
  NavLink,
  Outlet,
  useParams,
  useLocation,
} from "react-router-dom";
import Size from "./Size";
import Layout from "./Layout";
import Edge from "./Edge";
import Photos from "./Photos";

export default function CreateCustomPrint({ GetSizeData }) {
  const location = useLocation();

  const [dataFromChild, setDataFromChild] = useState(null);
  const [SizeData, setSizeData] = useState(null);
  const [CheckSizeRender, setCheckSizeRender] = useState(false);

  const handleDataFromChild = (data) => {
    // This function will be called by the child component
    // and will update the state in the parent component.
    console.log(data);
    setDataFromChild(data);
  };

  useEffect(() => {
    setCheckSizeRender(location.pathname.includes("size")); 
  }, [location]);

  useEffect(() => {
    setSizeData(GetSizeData);
    console.log(GetSizeData);
  }, [GetSizeData]);

  return (
    <div className="enhancements prices prices-one Print checkout">
      <main>
        <div className="tp-trend-product-5__area pb-10">
          <div className="container-fluid">
            <div className="row">
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="nav-Cards"
                  role="tabpanel"
                  aria-labelledby="nav-Cards-tab"
                  tabIndex={0}
                >
                  <div className="Section3   pb-50 two">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12 left-art">
                          <div className="Multi-tabs">
                            <ul
                              className="nav nav-pills"
                              id="pills-tab"
                              role="tablist"
                            >
                              <li
                                className="nav-item d-flex"
                                role="presentation"
                              >
                                <NavLink
                                  to={"layout"}
                                  className="nav-link btn btn-md-sm"
                                  id="pills-Tab2-tab"
                                  // data-bs-toggle="pill"
                                  // data-bs-target="#pills-tab2"
                                  type="button"
                                  role="tab"
                                  aria-controls="pills-tab2"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  <div className="image">
                                    <img
                                      src="assets/img/breadcrumb/Layout.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="riht-content mt-10">
                                    <span className="left">
                                      <p className="mb-0">Layout</p>
                                    </span>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                className="nav-item list-inline-item"
                                role="presentation"
                              >
                                <NavLink
                                  to={"size"}
                                  className="nav-link btn btn-md-sm disabled"
                                  id="pills-Tab3-tab"
                                  // data-bs-toggle="pill"
                                  // data-bs-target="#pills-tab3"
                                  type="button"
                                  role="tab"
                                  aria-controls="pills-tab3"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  <div className="image">
                                    <img
                                      src="assets/img/breadcrumb/size.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="riht-content mt-10">
                                    <span className="left">
                                      <p className="mb-0">Size</p>
                                    </span>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                className="nav-item list-inline-item"
                                role="presentation"
                              >
                                <NavLink
                                  to={"edge"}
                                  className="nav-link btn btn-md-sm"
                                  id="pills-Tab4-tab"
                                  // data-bs-toggle="pill"
                                  // data-bs-target="#pills-tab4 "
                                  type="button"
                                  role="tab"
                                  aria-controls="pills-tab4"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  <div className="image">
                                    <img
                                      src="assets/img/breadcrumb/Edge.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="riht-content mt-10">
                                    <span className="left">
                                      <p className="mb-0">Edge</p>
                                    </span>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                className="nav-item list-inline-item"
                                role="presentation"
                              >
                                <NavLink
                                  to={"service"}
                                  className="nav-link btn btn-md-sm"
                                  id="pills-Tab5-tab"
                                  // data-bs-toggle="pill"
                                  // data-bs-target="#pills-tab5 "
                                  type="button"
                                  role="tab"
                                  aria-controls="pills-tab5"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  <div className="image">
                                    <img
                                      src="assets/img/breadcrumb/Services.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="riht-content mt-10">
                                    <span className="left">
                                      <p className="mb-0">Services</p>
                                    </span>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                className="nav-item d-flex"
                                role="presentation"
                              >
                                <NavLink
                                  to={"photo"}
                                  className="nav-link btn btn-md-sm"
                                  id="pills-Tab1-tab"
                                  // data-bs-toggle="pill"
                                  // data-bs-target="#pills-tab1"
                                  type="button"
                                  role="tab "
                                  aria-controls="pills-tab1"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  <div className="image">
                                    <img
                                      src="assets/img/breadcrumb/photos.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="riht-content mt-10">
                                    <span className="left">
                                      <p className="mb-0">Photos</p>
                                    </span>
                                  </div>
                                </NavLink>
                              </li>
                            </ul>

                            {!CheckSizeRender && (
                              <div
                                className="tab-content"
                                id="pills-tabContent"
                              >
                                {/* <Outlet /> */}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 left-section">
                          {/* <div className="row lower-btn mt-2 mb-1"> */}
                          <div className="row lower-btn p-4 m-1">
                            <div className="col-xl-4 col-lg-4 col-md-12 m-auto text-center">
                              <h6 className="m-0 heading-connect main">
                                {/* <span>
                                  <i className="fa fa-arrow-left " />
                                </span> */}
                                &nbsp; Create Canvas Print
                              </h6>
                            </div>
                            <div className="col-xl-8 col-lg-8 col-md-12 m-auto text-center ">
                              {/* <a
                                className="tp-btn-lg large head mb-10"
                                href="#"
                              >
                                <span>
                                  <i className="fa fa-trash" />
                                </span>
                                Reset
                              </a>
                              <a
                                className="tp-btn-lg large head mt-10"
                                href="#"
                              >
                                <span>
                                  <i className="fa fa-undo" />
                                </span>
                                Undo
                              </a>
                              <a
                                className="tp-btn-lg large head mb-10"
                                href="#"
                              >
                                <span>
                                  <i className="fa fa-repeat" />
                                </span>
                                Redo
                              </a>
                              <a
                                className="tp-btn-lg large head mt-10"
                                href="#"
                              >
                                <span>
                                  <i className="fa fa-eye" />
                                </span>
                                Preview
                              </a> */}
                            </div>
                          </div>
                          {!CheckSizeRender && (
                            <div className="row data-show">
                              <div className="col-xl-12 col-lg-12 col-md-12 m-auto text-center ">
                                <div
                                  className="large-bg"
                                  style={{ width: "900px", height: "400px" }}
                                >
                                  {SizeData?.frame ? (
                                    <img
                                      style={{
                                        maxHeight: "350px",
                                        display: "block",
                                        marginInline: "auto",
                                      }}
                                      src={SizeData?.frame}
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src="assets/img/breadcrumb/large-image.png"
                                      alt=""
                                    />
                                  )}
                                </div>
                                <div className="tp-header__chat-box  pt-30">
                                  <Link
                                    to={"/add-to-cart"}
                                    className="tp-btn-lg large head price one me-1"
                                  >
                                    Save for Later
                                  </Link>
                                  {/* <a
                                  className="tp-btn-lg large head price one"
                                  href="added-to-cart.html"
                                >
                                  Save for Later
                                </a> */}
                                  <Link
                                    to={"/add-to-cart"}
                                    className="tp-btn-lg large head price two"
                                  >
                                    {" "}
                                    $129.99 | Add to Cart
                                  </Link>
                                  {/* <a
                                  className="tp-btn-lg large head price two"
                                  href="added-to-cart.html"
                                >
                                  $129.99 | Add to Cart
                                </a> */}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {CheckSizeRender && (
                        <div className="row px-3" > 
                          <div style={{borderTop:'2px solid #9a9ace', backgroundColor:'#fefefb'}} className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            {/* <Outlet /> */}
                          </div>
                           
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <UpperFooterSlider /> */}
      </main>
    </div>
  );
}
